import React, { Component } from "react";
import { Map, GoogleApiWrapper, Marker, InfoWindow } from "google-maps-react";
import PropTypes from "prop-types";

import { GOOGLE_MAPS_KEY } from "@/store/constants";

const mapStyles = {
  width: "100%",
  height: "100%",
};

export class MapContainerComponent extends Component {
  state = {
    activeMarker: null,
    showInfoWindow: false,
  };

  handleMarkerClick = (props, marker, e) => {
    this.setState({
      activeMarker: marker,
    });
    this.infoWindowComponent.openWindow();
  };

  handleMapClick = (mapProps, map, clickEvent) => {
    const { canAddMarker, setCoords } = this.props;
    if (!canAddMarker) {
      return;
    }
    if (!this.state.activeMarker) {
      this.setState({
        activeMarker: this.markerComponent.marker,
      });
    }
    const lat = clickEvent.latLng.lat();
    const lng = clickEvent.latLng.lng();
    this.state.activeMarker.setPosition({ lat, lng });
    setCoords(lat, lng);
  };

  handleOpenWindow = () => {
    this.setState({
      showInfoWindow: true,
    });
  };

  handleCloseWindow = () => {
    this.setState({
      showInfoWindow: false,
    });
  };

  render() {
    const { google, coordinates, name, canAddMarker } = this.props;
    const { activeMarker, showInfoWindow } = this.state;

    if (!google || !coordinates) {
      return <div>Loading...</div>;
    }

    return (
      <Map
        google={google}
        zoom={10}
        style={mapStyles}
        onClick={this.handleMapClick}
        initialCenter={{
          lat: coordinates.lat || 11.5564,
          lng: coordinates.lng || 104.9282,
        }}>
        <Marker
          marker={activeMarker}
          position={coordinates}
          name={name}
          draggable={canAddMarker}
          onDragend={this.handleMapClick}
          onClick={this.handleMarkerClick}
          visible={!!(coordinates.lat && coordinates.lng)}
          ref={marker => (this.markerComponent = marker)}
        />
        <InfoWindow
          marker={activeMarker}
          visible={showInfoWindow}
          ref={info => (this.infoWindowComponent = info)}
          onOpen={this.handleOpenWindow}
          onClose={this.handleCloseWindow}>
          <div>
            <span style={{ fontSize: "16px" }}>{name}</span>
          </div>
        </InfoWindow>
      </Map>
    );
  }
}

const MapContainer = GoogleApiWrapper({
  apiKey: GOOGLE_MAPS_KEY,
})(MapContainerComponent);

MapContainer.defaultProps = {
  name: "Merchant",
  canAddMarker: false,
  setCoords: (lat, lng) => {},
};

MapContainer.propTypes = {
  coordinates: PropTypes.object,
  name: PropTypes.string,
  canAddMarker: PropTypes.bool,
  setCoords: PropTypes.func,
};

export default MapContainer;
